<div class="file-icon">
	<img [src]="getIconPath()" [alt]="getFileExtension() + ' file icon'" />
</div>

